module.exports={
    "rollback": {
        "title": "Oops!",
        "message": "You gave the same answer to all the questions! For this test to validate, you need to answer to at least 1 question differently.",
        "continue": "Continue"
    },
    "share": {
        "text_a": "I took the UdeM Career Quiz and my profile category is",
        "text_b": ". What’s yours?",
        "link": "http://umtl.ca/careerquizfb",
        "general_share": {
            "link": "http://umtl.ca/careerquizfb",
            "facebook": {
                "name": "Be like me and take the Find Your Path – Career Quiz !",
                "description": "This interactive tool will help you explore the domains of interest to you, understand the characteristics of professionals working in these fields and choose the programs that inspire you. Click the following link: http://umtl.ca/careerquizfb Université de Montréal wishes you good luck finding your path!"
            },
            "twitter": "Be like me and take the Find Your Path – Career Quiz! UdeM wishes you good luck ! http://umtl.ca/careerquizfb",
            "email": {
                "subject": "Someone has recommended that you take the Find Your Path – Career Quiz",
                "content": "Hello, Someone has recommended that you take the Find Your Path – Career Quiz, an interactive tool that will help you explore the domains of interest to you, understand the characteristics of professionals working in these fields and choose the programs that inspire you. Click the following link: http://umtl.ca/careerquizfb UdeM wishes you good luck finding your path!"
            }
        }
    },
    "pub": {
        "title": "Did you know?"
    },
    "feedback": {
        "invalid_email": "Invalid email",
        "no_msg": "No message to send",
        "invalid_input": "There are one or more errors in your submission",
        "success": "« Your message has been sent successfully"
    },
    "question": {
        "do_you_agree": "Do you agree or disagree with this statement?",
        "you_are": "",
        "not_agree": "disagree",
        "agree": "strongly agree",
        "yes": "Yes",
        "no": "No",
        "i_agree": "I agree with this statement"
    },
    "global": {
        "title": "Find Your Path",
        "subtitle": "Career Quiz",
        "menu_bar": {
            "left_label": "Domains",
            "right_label": "My results"
        },
        "steps": [
            {
                "n": "1",
                "text": "Domains"
            },
            {
                "n": "2",
                "text": "Categories"
            },
            {
                "n": "3",
                "text": "Professions and programs"
            }
        ],
        "udem_link": "http://www.admission.umontreal.ca/"
    },
    "loading": {
        "text": "Analysis in progress"
    },
    "menu": {
        "title": "My results",
        "hi": "Hi",
        "high_score": "Your top score",
        "follow_scores": "You can follow your scores for each domains and categories.",
        "no_result": {
            "title": "You haven’t yet determined your categories for this domain.",
            "cta": "explore categories for this domain"
        }
    },
    "home": {
        "btn_begin_label": "Continue as a guest",
        "btn_login_label": "Log in",
        "btn_new_label": "New test",
        "btn_resume_label": "Continue my test",
        "btn_loggedin_begin_label": "Begin",
        "description": "For an optimal quiz experience, <a href=\"/en/connexion-modale-cursus/?reference=cursus-en\" data-account-links>log in</a> with your UdeM Explorer account. No account? <a href=\"/en/creer-un-compte-modale-cursus/?reference=cursus-en\" data-account-links>Create&nbsp;one.</a>",
        "presentation": {
            "title": "This exploratory process will help you:",
            "point_a": "Discover the domains of interest to you.",
            "point_b": "Understand the characteristics of professionals working in these fields.",
            "point_c": "Choose the programs that inspire you."
        },
        "login_lnk": "/en/connexion-modale-cursus/?reference=cursus-en",
        "create_account_lnk": "/en/creer-un-compte-modale-cursus/?reference=cursus-en"
    },
    "domains": [
        {
            "id": "1",
            "nom": "Human Beings",
            "letter": "H",
            "prc": "0",
            "slug": "humain"
        },
        {
            "id": "2",
            "nom": "Management",
            "letter": "M",
            "prc": "0",
            "slug": "management"
        },
        {
            "id": "3",
            "nom": "Living Organisms",
            "letter": "L",
            "prc": "0",
            "slug": "living"
        },
        {
            "id": "4",
            "nom": "Matter",
            "letter": "M",
            "prc": "0",
            "slug": "matiere"
        },
        {
            "id": "5",
            "nom": "Culture",
            "letter": "C",
            "prc": "0",
            "slug": "culture"
        }
    ],
    "footer": {
        "credits": "The Find Your Path – Career Quiz was developed and produced by Septembre éditeur. It was adapted by Yves Maurais, a career advisor, to facilitate the discovery of all the programs at Université de Montréal."
    },
    "instructions": {
        "caution": "Note!",
        "advices": "A few tips before you take the quiz",
        "advice_a": "Set aside 10 to 15 minutes.",
        "advice_b": "Ask a friend or family member to take the quiz for you and compare results.",
        "advice_c": "Choose a quiet location.",
        "advice_d": "To take the next step in finding your career path, meet with a career advisor at your school or <a href=\"https://admission.umontreal.ca/info-conseils/outils/orientation-et-information-scolaire-et-professionnelle/\" target=\"_blank\">a professional at the Université de Montréal.</a>",
        "advice_e": "Answer the questions based on your activities, interests and personality traits.",
        "advice_f": "Don’t spend too long on each question. Be spontaneous.",
        "continue": "Continue",
        "popup": {
            "title": "Navigation guide ",
            "browse_steps": "Navigue the steps",
            "view_results": "See your results",
            "continue": "Continue"
        }
    },
    "profile": {
        "domains_title": "Domains",
        "footnote": "We encourage you to explore all the domains where you have scored higher than 60% because the results of your personal and professional interests could lead to programs you may not have considered before. To do so, use the buttons to navigate or add the page to your favourites.",
        "domain": {
            "what_is": "What is the",
			"what_is_suffix": "domain about",
            "linked_families": "Linked categories to the",
			"linked_families_suffix": "domain",
            "explore_families": "Explore categories"
        }
    },
    "family": {
        "results_by_family": "Results by category",
        "explore": "Explore another domain",
        "learn_more": "Find out more about",
        "they_do": "In their work, they:",
        "they_are": "They are:",
        "they_love": "They like to:",
        "they_have": "They:",
        "they_prioritize": "They value:",
        "they_work": "They work primarily for/at/in:",
        "share_cta": "SHARE",
		"share_popup": {
			"title": "Did the Career Quiz help you?",
			"text": "Invite your friends on Facebook to take the test.",
			"cta": "Share your results!"
		},
        "programs": {
            "intro": "Programs at UdeM",
            "first_cycle": "Undergraduate programs",
            "superior_cycle": "Graduate programs",
            "credits": "credits"
        },
        "work": {
            "title": "Examples of possible professions",
            "intro": "People with this profile tend to hold the following positions. It’s important to note that many professions require an undergraduate degree or more. Be sure to get informed!"
        },
        "back_to_domains": "Back to domains",
        "next": "Next category"
    }
}
